import { configureStore } from '@reduxjs/toolkit';

import authSlice from './auth/auth.slice';
import commonSlice from './common/common.slice';
import progressSlice from './common/progress.slice';
import companySlice from './company/company.slice';
import profileSlice from './profile/profile.slice';
import searchSlice from './search/search.slice';
import socialMediaSlice from './socialMedia/socialMedia.slice';
import ideaHubSlice from './ideaHub/ideaHub.slice';
import programSlice from './program/program.slice';
import chatSlice from './chat/chat.slice';
import notificationsSlice from './notifications/notifications.slice';
import externalProgramSlice from './externalProgram/externalProgram.slice';
import externalApplicationSlice from './externalApplication/externalApplication.slice';
import cohortSlice from './cohort/cohort.slice';
import marketplace from './marketplace/marketplace.slice';
import landingPage from './landingpage/landingpage.slice';
import validationReducer from './validation/validationSlice';
import VentureReducer from './venture/venture.slice';
const store = configureStore({
  reducer: {
    auth: authSlice,
    common: commonSlice,
    progress: progressSlice,
    company: companySlice,
    profile: profileSlice,
    search: searchSlice,
    socialMedia: socialMediaSlice,
    ideaHub: ideaHubSlice,
    program: programSlice,
    chat: chatSlice,
    notifications: notificationsSlice,
    externalProgramSlice,
    externalApplicationSlice,
    cohort: cohortSlice,
    marketPlace: marketplace,
    validation: validationReducer,
    landingPage,
    venture: VentureReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
